import { ErrorHandler } from '@src/components/ErrorHandler';
import { Box } from '@uhg-abyss/web/ui/Box';
import { Divider } from '@uhg-abyss/web/ui/Divider';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
import { motion } from 'framer-motion';
import React from 'react';

import fields from './includes/fields.json';
import { Styles } from './includes/styles';

/**
 * Identifiers
 *
 * Displays a list of fields to filter by identifiers.
 *
 * @returns {Element}
 * @constructor
 */
export function Identifiers() {
  return (
    <ErrorHandler location="src/routes/private/Search/components/Filters/components/Identifiers/Identifiers.jsx">
      <Styles>
        <motion.div
          animate="open"
          initial={{ opacity: 0 }}
          variants={{
            closed: { opacity: 0 },
            open: { opacity: 1 },
          }}
        >
          <Box className="box row border">
            <Grid>
              <Grid.Col span={{ xs: '100%' }}>
                <Heading color="black" offset={4}>
                  Identifiers
                </Heading>
              </Grid.Col>
            </Grid>
            <Divider color="transparent" margin="$md" />
            <Grid>
              <Grid.Col span="20%">
                <TextInput {...fields?.policyNumber} />
              </Grid.Col>
              <Grid.Col span="20%">
                <TextInput {...fields?.memberId} />
              </Grid.Col>
              <Grid.Col span="20%">
                <TextInput {...fields?.memberAltId} />
              </Grid.Col>
              <Grid.Col span="20%">
                <TextInput {...fields?.enterpriseId} />
              </Grid.Col>
              <Grid.Col span="20%">
                <TextInput {...fields?.cagId} />
              </Grid.Col>
            </Grid>
          </Box>
        </motion.div>
      </Styles>
    </ErrorHandler>
  );
}
